<template>
    <email-preview-modal :show="showModal" :emailData="form" :btnDisabled="form.processing" @close="showModal = false" @sendEmail="sendEmail"></email-preview-modal>
    <app-layout>
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <jet-form-section @submitted="showPreview">
                <template #title>
                    Send Email
                </template>

                <template #description>
                    broadcast to all users
                </template>

                <template #form>
                    <div class="col-span-6 sm:col-span-4">
                        <jet-label for="to" value="To" />
                        <jet-input id="toDummy" type="text" class="mt-1 block w-full" :readonly="form.isEmailsLoaded" placeholder="Send to all the active users" v-show="form.isEmailsLoaded"/>
                        <jet-input id="to" type="email" class="mt-1 block w-full" v-model="form.to" :readonly="form.isEmailsLoaded" v-show="!form.isEmailsLoaded"/>
                        <jet-input-error :message="form.errors.to" class="mt-2" />
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <jet-label for="subject" value="Subject" />
                        <jet-input id="subject" type="text" class="mt-1 block w-full" v-model="form.subject" required autofocus/>
                        <jet-input-error :message="form.errors.subject" class="mt-2" />
                    </div>

                    <div class="email-body col-span-6 sm:col-span-4">
                        <jet-label for="body" value="Body" />
                        <QuillEditor v-model:content="inputValue" content-type="html" theme="snow" scrollingContainer="true"/>
                        <jet-input-error :message="form.errors.body" class="mt-2 email-content" />
                    </div>
                </template>

                <template #actions>
                    <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                        Sent.
                    </jet-action-message>

                    <jet-button :disabled="form.processing || !(inputValue.trim().length && form.subject && form.to)">
                        Send
                    </jet-button>
                </template>
            </jet-form-section>
        </div>
    </app-layout>
</template>


<script>
import AppLayout from '@/Layouts/AppLayout'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import jetTextarea from '@/Jetstream/Textarea'
import axios from 'axios'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import EmailPreviewModal from './EmailPreviewModal.vue';

export default {
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        jetTextarea,
        QuillEditor,
        EmailPreviewModal
    },

    data() {
        return {
            form: this.$inertia.form({
                to: '',
                subject: '',
                body: '',
                isEmailsLoaded: false,
            }),
            inputValue: '',
            showModal: false,
        }
    },

    created() {
        this.getUsers();
    },

    methods: {
        getUsers() {
            axios.get('/api/users?status=active')
                .then((res) => {
                    const emails = res.data.data.map(user => user.id);
                    this.form.to = emails;
                    this.form.isEmailsLoaded = true;
                });
        },
        sendEmail() {
            this.form.body = this.inputValue;
            this.form.post(route('broadcast.email'), {
                errorBag: 'sendEmail',
                preserveScroll: true,
                onSuccess: () => {
                    this.form.subject = '';
                    this.form.body = '';
                    this.showModal = false;
                    this.inputValue = ' ';
                }
            })
        },
        showPreview() {
            this.form.body = this.inputValue;
            this.showModal = true;
        },
    },
}
</script>

<style scoped>
    .email-body {
        min-height: 200px;
        margin-bottom: 50px;
    }

    .email-content {
        font-family: Helvetica, Arial, sans-serif;
        line-height: 1.3;
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%
    }

    #outlook a {
        padding: 0
    }

    table,
    td {
        border-collapse: collapse;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt
    }

    img {
        border: 0;
        height: auto;
        line-height: 100%;
        outline: none;
        text-decoration: none;
        -ms-interpolation-mode: bicubic
    }

    p {
        display: block;
        margin: 13px 0
    }

    [owa] .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%
    }

    [owa] .mj-column-per-33-333333333333336 {
        width: 33.333333333333336% !important;
        max-width: 33.333333333333336%
    }

    .hero_bg_img {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .txt_small div,
    .txt_small p {
        font-size: 14px !important
    }

    .explore_tiles .txt_small div {
        text-transform: uppercase !important
    }

    @media only screen and (min-width:481px) {
        .mj-column-per-100 {
            width: 100% !important;
            max-width: 100%
        }

        .mj-column-per-33-333333333333336 {
            width: 33.333333333333336% !important;
            max-width: 33.333333333333336%
        }
    }

    @media only screen and (max-width:480px) {
        h2 {
            font-size: 22px !important
        }

        table.mj-full-width-mobile {
            width: 100% !important
        }

        td.mj-full-width-mobile {
            width: 100% !important
        }

        .pad_sml {
            padding: 20px !important
        }

        .pad_sml_hdr {
            padding: 30px 20px 10px !important
        }

        .pad_copyright {
            padding: 0 20px !important
        }

        .hero_hdr,
        .hero_hdr h1 {
            font-size: 28px !important
        }

        .txt_small div,
        .txt_small p {
            font-size: 13px !important
        }

        .sec_content p {
            font-size: 16px !important
        }

        .explore_tiles>table>tbody>tr>td {
            padding: 0 8px 20px !important
        }
    }

</style>
